import {
  updateTransitCard as updateTransitCardAPI,
  addTransitCard as addTransitCardAPI,
  transferPass as transferPassAPI
} from '../Api';

const useTransitCard = (
  handleApiCallWithToken,
  handleApiRes,
  authAndContent
) => {
  const addTransitCard = (...args) =>
    handleApiCallWithToken(addTransitCardAPI, ...args).then(res =>
      handleApiRes({
        res,
        successMsg: authAndContent.localeText(
          'rw_msg_card_successfully_registered',
          'Card Successfully Registered'
        ),
        errorMsg: 'Failed to add Transit Card'
      })
    );

  const updateTransitCard = (...args) =>
    handleApiCallWithToken(updateTransitCardAPI, ...args).then(res =>
      handleApiRes({
        res,
        successMsg: authAndContent.localeText(
          'rw_msg_card_details_updated',
          'Card Details Updated'
        )
      })
    );

  const transferPass = (...args) =>
    handleApiCallWithToken(transferPassAPI, ...args).then(res =>
      handleApiRes({
        res,
        successMsg: authAndContent.localeText(
          'rw_msg_pass_transfer_successful',
          'Pass Successfully Transferred'
        ),
        errorMsg: 'Transfer Failed'
      })
    );

  return {
    addTransitCard,
    updateTransitCard,
    transferPass
  };
};

export default useTransitCard;
